import Team from './Team';

class Teams {
  constructor(app) {
    this.app = app;
  }

  async get(args, config = {}) {
    const params = new URLSearchParams();

    const result = {
      total: 0,
      data: [],
    };

    if (args.cache) {
      params.append('cache', args.cache);

      if (args.cachettl) {
        params.append('cachettl', args.cachettl);
      }
    }

    if (args.conferences) {
      for (const conference of args.conferences) {
        params.append('conferences[]', conference);
      }
    }

    if (args.custom && Array.isArray(args.custom)) {
      for (const val of args.custom) {
        params.append('custom[]', val);
      }
    }

    if (args.divisions) {
      for (const division of args.divisions) {
        params.append('divisions[]', division);
      }
    }

    if (args.id) {
      params.append('ids[]', args.id);
    }

    if (args.ids) {
      for (const id of args.ids) {
        params.append('ids[]', id);
      }
    }

    if (args.exclude) {
      for (const id of args.exclude) {
        params.append('exclude[]', id);
      }
    }

    if (args.external) {
      params.append('external', args.external);
    }

    if (args.league) {
      params.append('league', args.league);
    }

    if (args.leagues) {
      for (const league of args.leagues) {
        params.append('leagues[]', league);
      }
    }

    if (args.level) {
      params.append('level', args.level);
    }

    if (args.levels) {
      for (const level of args.levels) {
        params.append('levels[]', level);
      }
    }

    if (args.limit) {
      params.append('limit', args.limit);
    }

    if (args.local && args.local.active) {
      params.append('local[active]', args.local.active);

      if (args.local.boundary) {
        params.append('local[boundary]', args.local.boundary);
      }
    }

    if ((! args.local || ! args.local.active) && args.location) {
      if (args.location.lat) {
        params.append('location[lat]', args.location.lat);
      }

      if (args.location.lon) {
        params.append('location[lon]', args.location.lon);
      }

      if (args.location.region) {
        params.append('location[region]', args.location.region);
      }
    }

    if (args.nonce) {
      params.append('nonce', args.nonce);
    }

    if (args.orderby) {
      params.append('orderby', args.orderby);
    }

    if (args.page) {
      params.append('page', args.page);
    }

    if (args.postal) {
      params.append('postal', args.postal);
    }

    if (args.ranges) {
      for (const range of args.ranges) {
        params.append('ranges[]', range);
      }
    }

    if (args.search) {
      params.append('search', args.search);
    }

    if (args.sport) {
      params.append('sport', args.sport);
    }

    if (args.sports) {
      for (const sport of args.sports) {
        params.append('sports[]', sport);
      }
    }

    if (args.state) {
      params.append('state', args.state);
    }

    if (args.title) {
      params.append('title', args.title);
    }

    if (config.follows) {
      const follows = await window.bvm.app.users.getFollows();
      follows.teams.forEach(team => {
        result.total += 1;
        result.data.push(team);
      });
      return result;
    }

    if(args.mode) {
      params.append('mode', args.mode)
    }

    const response = await this.app.api.get('teams', params, config);

    if (response.isSuccess()) {
      response.getData().forEach((item) => {
        result.total += 1;
        result.data.push(new Team()
          .setId(item.id)
          .setSsId(item.ssid)
          .setTitle(item.title)
          .setShortTitle(item.shortTitle)
          .setSubtitle(item.subtitle)
          .setSlug(item.slug)
          .setUrl(item.url)
          .setLevel(item.level)
          .setLogo(item.logo)
          .setLogoHTML(item.logoHTML)
          .setLeague(item.league)
          .setAddress(item.address)
          .setSport(item.sport)
          .setSquads(item.squads)
          .setMascot(item.mascot)
        );

        /**
         * Hack for handling squads as a teams. In terms of business domain
         * it might be misleading, but in terms of data structure its ok.
         *
         * @todo Create squad JS object, or refactor Teams domain.
         */
        if (config.squads) {
          if (item.squads.length > 0) {
            item.squads.forEach((squad) => {
              if (! args.title && ! ['football', 'basketball'].includes(squad.sport)) {
                return;
              }

              result.total += 1;
              result.data.push(new Team()
                .setId(item.id)
                .setSsId(item.ssid)
                .setTitle(`${item.title} ${squad.title}`)
                .setShortTitle(item.shortTitle)
                .setSubtitle(squad.title)
                .setSlug(squad.slug)
                .setUrl(squad.url)
                .setLogo(item.logo)
                .setLogoHTML(item.logoHTML)
                .setAddress(item.address)
                .setSport(squad.sport)
                .setGender(squad.gender)
                .setMascot(item.mascot)
              );
            });
          }
        }
      });
    } else {
      throw new Error(response.getMessage());
    }

    return result;
  }
}

export default Teams;
